
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/implementation-guide",
      function () {
        return require("private-next-pages/admin/implementation-guide/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/implementation-guide"])
      });
    }
  